import React from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import Skills from "../../containers/skills/Skills";

function Home(props) {
  return (
    <div>
      <Header theme={props.theme} setTheme={props.setTheme} />
      <div className="main-content">
        <Greeting theme={props.theme} />
        <Skills theme={props.theme} />
      </div>
    </div>
  );
}

export default Home;
